module.exports = __webpack_public_path__ + "img/anger.eb123ffe.svg";